import { getHumanReadableNameCellHelper } from "../../../../../../../utils";
import { ValueLanguage } from "../../../../../../../assets/languages/langs";

import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model["orderToServices"],
	language?: ValueLanguage,
): string =>
	item
		?.map((orderToService) =>
			getHumanReadableNameCellHelper(
				orderToService?.service?.name,
				language,
			),
		)
		?.filter(Boolean)
		?.join(", ") ?? "";

export default cellProcessing;
